import { render, staticRenderFns } from "./DatasetDetails.vue?vue&type=template&id=ab3b837a&scoped=true&"
import script from "./DatasetDetails.vue?vue&type=script&lang=js&"
export * from "./DatasetDetails.vue?vue&type=script&lang=js&"
import style0 from "./DatasetDetails.vue?vue&type=style&index=0&id=ab3b837a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3b837a",
  null
  
)

export default component.exports